export const FILE_EXTENSION_PNG: string = 'png';
export const FILE_EXTENSION_JPG: string = 'jpg';
export const FILE_EXTENSION_JPEG: string = 'jpeg';
export const FILE_EXTENSION_GIF: string = 'gif';
export const FILE_EXTENSION_PDF: string = 'pdf';

export const FILE_EXTENSION_LIST_IMAGE: string[] = [
  FILE_EXTENSION_PNG,
  FILE_EXTENSION_JPG,
  FILE_EXTENSION_JPEG,
  FILE_EXTENSION_GIF,
];

export const FILE_EXTENSION_LIST_ANALYZABLE: string[] = [
  FILE_EXTENSION_PDF,
];

export const FILE_EXTENSION_LIST_ALL: string[] = [];
